export const ACTIVATION_UI_ERROR_CODES = {
  GET_HASHES_FAILED: 'GET_HASHES_FAILED',
  ACTIVATION_FAILED: 'ACTIVATION FAILED',
  CREATE_TENANT_FAILED: 'CREATE_TENANT_FAILED',
  NO_ACCESS_TO_CSP: 'NO_ACCESS_TO_CSP',
  NO_ACCESS_TO_REGION: 'NO_ACCESS_TO_REGION',
  NO_ACCESS_TO_CDL: 'NO_ACCESS_TO_CDL',
  NO_REGION_AVAILABLE: 'NO_REGION_AVAILABLE',
  INSTANCE_ALREADY_EXISTS: 'INSTANCE_ALREADY_EXISTS',
  CDL_QUANTITY_INPUT_ERROR: 'CDL_QUANTITY_INPUT_ERROR',
  NO_ABSOLUTE_TSG_ACCESS: 'NO_ABSOLUTE_TSG_ACCESS',
  INSTANCE_FROM_DIFF_SOURCE: 'INSTANCE_FROM_DIFF_SOURCE',
  ADD_ON_PRIMARY_INSTANCE_NOT_EXISTS: 'ADD_ON_PRIMARY_INSTANCE_NOT_EXISTS',
  HASH_FULLY_ACTIVATED: 'HASH_FULLY_ACTIVATED',
  TREE_LOCK: 'TREE_LOCK',
  CSP_LOCK: 'CSP_LOCK',
  CANNOT_CREATE_TSG: 'CANNOT_CREATE_TSG',
  INSTANCE_GET_FAILED: 'INSTANCE_GET_FAILED',
  NO_TSG_SELECTED: 'NO_TSG_SELECTED'
}

export const ACTIVATION_ERROR_CODE_TO_DISPLAY_MSG_MAP = {
  [ACTIVATION_UI_ERROR_CODES.GET_HASHES_FAILED]: 'Failed to decode the hash. Please contact support!',
  [ACTIVATION_UI_ERROR_CODES.ACTIVATION_FAILED]: 'Activation Failed. Please contact support!',
  [ACTIVATION_UI_ERROR_CODES.CREATE_TENANT_FAILED]: 'Failed to create a new Tenant. Please contact support!',
  [ACTIVATION_UI_ERROR_CODES.NO_ACCESS_TO_CSP]: 'User dont have access to the CSP which is activated in the instance',
  [ACTIVATION_UI_ERROR_CODES.NO_ACCESS_TO_REGION]: 'User dont have access to the Region which is activated in the instance',
  [ACTIVATION_UI_ERROR_CODES.NO_ACCESS_TO_CDL]: 'Cortex Data Lake service unavailable.',
  [ACTIVATION_UI_ERROR_CODES.NO_REGION_AVAILABLE]: 'No region compatibale with the instance region running inside this Tenant',
  [ACTIVATION_UI_ERROR_CODES.INSTANCE_ALREADY_EXISTS]: '{0} service is already activated.',
  [ACTIVATION_UI_ERROR_CODES.ADD_ON_PRIMARY_INSTANCE_NOT_EXISTS]: '{0} Subscription does not exist',
  [ACTIVATION_UI_ERROR_CODES.CDL_QUANTITY_INPUT_ERROR]: 'Cdl quantity is required,should be less than purchased size',
  [ACTIVATION_UI_ERROR_CODES.NO_ABSOLUTE_TSG_ACCESS]: 'User don\'t have access to absolute TSG for selected TSG',
  [ACTIVATION_UI_ERROR_CODES.INSTANCE_FROM_DIFF_SOURCE]: 'instance running on absolute tsg is from another license source',
  [ACTIVATION_UI_ERROR_CODES.TREE_LOCK]: 'The TSG you selected does not have the same SDWAN license source',
  [ACTIVATION_UI_ERROR_CODES.CSP_LOCK]: 'The Support Account you selected does not match SDWAN instance from root TSG',
  [ACTIVATION_UI_ERROR_CODES.HASH_FULLY_ACTIVATED]: 'This magic link is fully activated',
  [ACTIVATION_UI_ERROR_CODES.CANNOT_CREATE_TSG]: 'Cannot create child TSG because the selected TSG has panorama services running',
  [ACTIVATION_UI_ERROR_CODES.INSTANCE_GET_FAILED]: 'Getting instance failed, please retry.',
  [ACTIVATION_UI_ERROR_CODES.NO_TSG_SELECTED]: 'Please select TSG to continue!',

}

export const GENERIC_ERROR_MESSAGE = 'An error occured. Please contact support!'

export const getErrorMessage = (errorCode: string) => {
  return ACTIVATION_ERROR_CODE_TO_DISPLAY_MSG_MAP[errorCode] || GENERIC_ERROR_MESSAGE
}
